import {
  SOURCE,
  ends,
} from "./constant"

export function imgCompress(dom, callback, errorCallback) {
  if (!dom)
    return
  const MAX_SIZE = 8 * 1024 * 1024;
  let FILE_SIZE = 0;
  dom.onchange = function () {
    const rate = 1;
    let file = dom.files[0];
    if (file.size > MAX_SIZE) {
      errorCallback && errorCallback();
      return
    }
    FILE_SIZE = file.size;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let url = e.target.result;
      let img = new Image;
      img.src = url;
      img.onload = function () {
        let imgWidth = img.width;
        let imgHeight = img.height;
        let imgRate = (imgWidth < imgHeight ?
          imgWidth / imgHeight :
          imgHeight / imgWidth) / rate;
        canvas.width = imgWidth * imgRate;
        canvas.height = imgHeight * imgRate;
        // ctx.translate(imgWidth * imgRate, imgHeight * imgRate);
        // ctx.rotate(Math.PI)

        // let userAgent = navigator.userAgent.toLowerCase();
        // let andVar = userAgent.match(/sm-/i);

        // ios系统是否小于13.4
        let isRotate = true;
        // @20201230 解决图片旋转的方法一：判断机型（判断情况太多，所以使用方法二）
        // if (ends.isIOS) {
        //   let iosVer = getIosVerStr();
        //   isRotate = isVerLessThan(iosVer, '13.4');
        // }
        // if (isSamsung()) {
        //   let androidVerStr = getAndroidVerStr();
        //   isRotate = isVerLessThan(androidVerStr, '9');
        // }

        // @20201230 解决图片旋转的方法一：检查浏览器是否支持自动图像定向
        if (window.browserImgRotate) {
          isRotate = false;
        }

        if (isRotate) {
          let o = _getFileOrientation(_base64ToArrayBuffer(url));
          if (o == 6) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.rotate(90 / 180 * Math.PI)
            ctx.translate(0, -imgHeight * imgRate);
          } else if (o == 8) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.translate(0, imgWidth * imgRate);
            ctx.rotate(270 / 180 * Math.PI);
          } else if (o == 3) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.translate(imgWidth * imgRate, imgHeight * imgRate);
            ctx.rotate(180 / 180 * Math.PI);
          }
        }

        ctx.drawImage(img, 0, 0, imgWidth, imgHeight, 0, 0, imgWidth *
          imgRate, imgHeight * imgRate);
        let imgUrl = canvas.toDataURL('image/jpeg');
        canvas = null;
        callback && callback.call(this, {
          imageBase64String: imgUrl,
          errorCode: 104,
          originSize: FILE_SIZE
        })
      }
    }
  }
}
// 获取ios系统版本
const getIosVerStr = () => {
  let userAgent = navigator.userAgent;
  let reg = /CPU iPhone OS (.*?) like Mac OS/i;
  let verStr = userAgent.match(reg)[1];
  return verStr.replace(/_/g, '.');
}
// 获取android系统版本
const getAndroidVerStr = () => {
  let userAgent = navigator.userAgent;
  let reg = /android (.*?);/i;
  let verStr = userAgent.match(reg)[1];
  return verStr;
}
// 判断是否是三星
const isSamsung = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  let isSamsung = (/sm-/i).test(userAgent);
  return isSamsung;
}
// ios版本比较
const isVerLessThan = (ver, compareVer) => {
  let verArr = ver.split('.');
  let compareVerArr = compareVer.split('.');
  let minLength = Math.min(compareVerArr.length, verArr.length);
  for (let i = 0; i < minLength; i++) {
    if (+verArr[i] < +compareVerArr[i]) {
      return true;
    } else if (+verArr[i] > +compareVerArr[i]) {
      return false;
    }
  }
  return false;
}

// 解决图片旋转的方法二
export const imgRotate = () => {
  let testImageURL =
    'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
    'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
    'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
    'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/x' +
    'ABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAA' +
    'AAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQ' +
    'voP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXw' +
    'H/9k='
  let img = document.createElement('img')
  img.onload = function () {
    window.browserImgRotate = img.width === 2 && img.height === 3
  }
  img.src = testImageURL
}

/* 获取拍照时照片的方向，可根据方向对图片展示时进行相应旋转操作，保证图片0度显示
  返回值----------------    1    0°
                           6    顺时针90°
                           8    逆时针90°
                           3    180°
*/
function _getFileOrientation(arrayBuffer) {
  var view = new DataView(arrayBuffer)
  if (view.getUint16(0, false) != 0xFFD8) return -2
  var length = view.byteLength
  var offset = 2
  while (offset < length) {
    var marker = view.getUint16(offset, false)
    offset += 2
    if (marker == 0xFFE1) {
      if (view.getUint32(offset += 2, false) != 0x45786966) return -1
      var little = view.getUint16(offset += 6, false) == 0x4949
      offset += view.getUint32(offset + 4, little)
      var tags = view.getUint16(offset, little)
      offset += 2
      for (var i = 0; i < tags; i++) {
        if (view.getUint16(offset + (i * 12), little) == 0x0112) {
          return view.getUint16(offset + (i * 12) + 8, little)
        }
      }
    } else if ((marker & 0xFF00) != 0xFF00) break
    else offset += view.getUint16(offset, false)
  }
  return -1
}

function _base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data:([^;]+);base64,/gmi, '')
  var binaryString = atob(base64)
  var len = binaryString.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

export function pdfReader(dom, callback, errorCallback) {
  if (!dom)
    return
  const MAX_SIZE = 8 * 1024 * 1024;
  let FILE_SIZE = 0;
  dom.onchange = function () {

    let file = dom.files[0];
    // 选择的不是PDF文件返回错误码-4
    if (file.type !== 'application/pdf') {
      callback && callback.call(this, {
        errorCode: -4,
      })
      return
    }
    if (file.size > MAX_SIZE) {
      errorCallback && errorCallback();
      return
    }
    FILE_SIZE = file.size;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      let url = e.target.result;
      callback && callback.call(this, {
        fileBase64String: url,
        errorCode: 104,
        originSize: FILE_SIZE,
        fileType: file.type
      })
    }
  }
}
// 新开webView
function openPage(url) {
  Fusion.openPage && Fusion.openPage({
    url: url,
    newWindow: true,
  });
}
// 新开webView(登录后才能使用)
function openNewPage(url) {
  let module = null;
  if (Fusion.loadModule && Fusion.loadModule) {
    module = Fusion.loadModule("newPageModule")
  }
  if (module.openNewPage) {
    module.openNewPage(
      {
        url: url
      },
      (res) => { }
    )
  }
}

function openWebview(url) {
  // let up = new URLSearchParams(location.search)
  // let terminal_id = up.get("terminal_id");
  // if (terminal_id == 5 || terminal_id == 7) {
  //   // 巴西99司机端 || 乘客端
  //   openPage(url)
  // } else {
  //   // global司机端(各版本)
  //   openNewPage(url)
  // }
  openPage(url)
}

function goThirdLink({ up, url, target }) {
  if (!url) {
    return
  }
  if (up) {
    url = `${url}${url.includes('?') ? '&' : '?'}${up}`;
  }
  if (target === 'blank') {
    if (ends.inApp) {
      openWebview(url)
    } else {
      window.open(url);
    }
  } else {
    window.location.href = url;
  }
}

function _getImgUrl(file) {
  let url = null;
  if (window.createObjectURL != undefined) { // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) { // mozilla(firefox)
    url = window
      .URL
      .createObjectURL(file);
  } else if (window.webkitURL != undefined) { // web_kit or chrome
    url = window
      .webkitURL
      .createObjectURL(file);
  }
  return url;
}


function formatCPFBr(str, clear) {
  let tempVal = str.slice(0, 14).replace(/\D/g, "");
  if (clear) {
    return tempVal
  }
  let l = tempVal.length;
  //076.571.654-21
  if (l === 3 || l === 6 || l === 9) return str;
  let result = "";
  for (let i = 0; i < l; i++) {
    result += tempVal[i];
    if (i === 2 || i === 5) {
      result += "."
    } else if (i === 8) {
      result += "-"
    }
  }
  return result
}

function formatCNPJBr(str, clear) {

  let tempVal = str.slice(0, 18).replace(/\D/g, "");
  if (clear) {
    return tempVal
  }
  let l = tempVal.length;
  //77.188.118/0001-10
  if (l === 2 || l === 5 || l === 8 || l === 12) return str;
  let result = "";
  for (let i = 0; i < l; i++) {
    result += tempVal[i];
    if (i === 1 || i === 4) {
      result += "."
    } else if (i === 7) {
      result += "/"
    } else if (i === 11) {
      result += "-"
    }
  }
  return result
}

function formatAccent(str) {
  const accents =
    "ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏìíîïÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚšśŤťŸÝÿýŽŻŹžżź";
  const unAccents =
    "AAAAAAAaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIiiiiUUUUUuuuuuLLLlllNNNnnnRrSSssTtYYyyZZZzzz";
  str = str.split("");
  const strLen = str.length;
  let i, x;
  for (i = 0; i < strLen; i++) {
    if ((x = accents.indexOf(str[i])) != -1) {
      str[i] = unAccents[x];
    }
  }
  return str.join("");
}

function formatCURPMx(str) {
  return formatAccent(str).toUpperCase()
}

function formatRUT(str, clear) {
  if (clear) {
    return str.replace(/[\W_]/g, "")
  }
  return str.toUpperCase()
}

function formatCarPlateBr(val, clear) {
  if (clear) {
    return val.replace(/[\W_]/g, "")
  }
  const carPlateInputReg = /^([A-Z]{3})([A-Z0-9]{1})$/;
  return val.toUpperCase().replace(carPlateInputReg, ($1, $2, $3) => $2 + "-" +
    $3);
}
function formatCURPCr(val, clear) {
  let t = val;
  val = val.replace(/[\W_]/g, "").toUpperCase();
  if (clear) {
    return val
  }
  if (t.length === 3 && t.slice(2) === '-') {
    return t.toUpperCase();
  }
  return val.length <= 2 ? val : `${val.slice(0, 2)}${val.slice(2, 3) === '-' ? "" : "-"}${val.slice(2)}`
}

//更新form状态，需要与父级通信时，触发此更新，大多数是通知父级新值已经可用
function emitFormUpdate(context, idx, ...a) {
  context.$emit("form-update", idx, ...a);
}


let up = new URLSearchParams(location.search);

function getEnd() {
  let up = new URLSearchParams(location.search);
  const bundle_id = up.get('bundle_id') || "";
  const fleet_register_pc = up.get('fleet_register_pc')
  const from_fleetPC = up.get('from_fleetPC');
  const from_fleetAPP = up.get('from_fleetAPP');
  let end = "WebEnd" // 手机浏览器
  if (bundle_id.indexOf(SOURCE.fleetApp) > -1) {
    end = "FleetAppEnd"; // Fleet APP 巴西
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && (fleet_register_pc == 1 || from_fleetPC == 1)) {
    end = "FleetPCEnd" // Fleet PC
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && from_fleetAPP == 1) {
    end = "FleetEnd" // Fleet APP 墨西哥
  } else if (bundle_id.indexOf(SOURCE.global) > -1) {
    end = "DriverEnd" // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.br_99) > -1) {
    end = "DriverEnd" // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.globalIos) > -1) {
    end = 'DriverEnd'; // 手机司机端(ios)
  } else if (bundle_id.indexOf(SOURCE.minibus_new) > -1 || bundle_id.indexOf(SOURCE.minibus_old) > -1) {
    end = 'DriverEnd'; // 小巴司机端
  } else if ((ends.isIOS && (up.get('datatype') == 101)) ||
    (ends.isAndroid && (up.get('datatype') == 1))) {
    //乘客端
    end = "PassengerEnd"
  } else if (ends.isPC) {
    //官方网站
    end = "PCEnd"
  }
  return end
}
function fireBase(key, attrs = {}) {
  Fusion.track_event &&
    Fusion.track_event({
      is_upload_firebase: 1,
      track_key: key,
      attrs
    });
}

// 获取url上的机房
function getDomainSuffix() {
  let pageDomain = location.hostname;
  let pageDomainArr = pageDomain.split('.');

  // sim环境不判断
  let ibtTestDomain = /sim[0-9]+[-\w]+test.intra.xiaojukeji.com$/;

  if (ibtTestDomain.test(pageDomain)) {
    return '';
  }

  if (pageDomainArr[0].indexOf('-') > 0) {
    let domainPreFixArr = pageDomainArr[0].split('-');
    let pageSuffix = domainPreFixArr[domainPreFixArr.length - 1];
    pageSuffix = '-' + pageSuffix;
    return pageSuffix;
  }
  return '';
}

// 获取定位方法
function getLocation(cb) {
  let up = new URLSearchParams(location.search);
  let lng = up.get("lng"),
    lat = up.get("lat");
  if (lng && lat) {
    cb && cb(lng, lat);
  } else {
    /**
     *  获取经纬度信息
     *  position_option 获取经纬度信息的配置项
     *  getPositionSuccess 信息获取成功函数
     *  getPositionError 信息获取失败函数
     */
    let position_option = {
      enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
      maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
      timeout: 3000 //超时时间
    };
    navigator.geolocation.getCurrentPosition(
      getPositionSuccess,
      getPositionError,
      position_option
    );
    function getPositionSuccess(position) {
      cb && cb(
        position.coords.longitude,
        position.coords.latitude
      );
    }
    function getPositionError(e) {
      console.log(e, "get position fail!");
    }
  }
}

// 计算跳转时长
function computeJumpTime(_this) {
  const currentTime = Date.now()
  const cur_comp_name = _this.$options.name
  const up = new URLSearchParams(window.location.search);
  // console.log("cur_comp_name", cur_comp_name);
  // console.log("_page_jump_time", _this._page_jump_time);
  // console.log("_page_stay_time", _this._page_stay_time);
  // console.log("currentTime", currentTime);
  // 如果有上次跳转时间则进行计算
  if(_this._page_jump_time > 0) {
    let jump_time =  currentTime - _this._page_jump_time
    // console.log("jump_time", jump_time);
    // console.log(_this._route_path[_this._route_path.length - 1] + "跳转" + cur_comp_name + "时长: ", jump_time/1000 + "s")
    if(window.Omega && window.Omega.trackEvent) {
      try {
        Omega.trackEvent("tech_register_page_jump_time", "", {
          oid: up.get("oid") || window.Omega.getOmgid(),
          driver_id: up.get("uid") || _this._uuid + '',
          from: _this._route_path[_this._route_path.length - 1],
          to: cur_comp_name,
          jump_time
        });
      } catch (error) {}
    }
  } else {
    // 第一次进入app设置为_page_jump_time时间
    _this.setState({ _page_jump_time: currentTime })
  }
  _this.setState({ _page_stay_time: currentTime })
  // 模拟路由记录，因为main不放入，所以第一次放入app
  if(_this._route_path.length === 0) {
    _this.setState({ _route_path: ["App"] })
  } else {
    _this.setState({ _route_path: [..._this._route_path, cur_comp_name]} )
  }
}

// 计算停留时长
function computeStayTime (_this) {
  const currentTime = Date.now()
  const cur_comp_name = _this.$options.name
  // console.log("cur_comp_name", cur_comp_name);
  // console.log("_page_stay_time", _this._page_stay_time);
  // console.log("currentTime", currentTime);
  let stay_time =  currentTime - _this._page_stay_time
  const up = new URLSearchParams(window.location.search);
  // console.log(cur_comp_name + "页面停留时长: ", stay_time / 1000 + "s")
  if(window.Omega && window.Omega.trackEvent) {
    try {
      Omega.trackEvent("tech_register_page_stay_time", "", {
        oid: up.get("oid") || window.Omega.getOmgid(),
        driver_id: up.get("uid") || _this._uuid + '',
        cur_comp: cur_comp_name,
        stay_time
      });
    } catch (error) {}
  }
  _this.setState({ _page_jump_time: currentTime })
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document && document.cookie && document.cookie.split(";") || [];
  if (ca.length === 0) return "";

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }

  return "";
}

function compareVersions(v1, v2) { // v1>v2: 1, v1<v2: -1, v1=v2:0
  var v1parts = v1.split('.');
  var v2parts = v2.split('.');
  
  for (var i = 0; i < v1parts.length; ++i) {
    if (v2parts.length == i) {
      return 1;
    }
    
    if (v1parts[i] == v2parts[i]) {
      continue;
    }
    else if (v1parts[i] > v2parts[i]) {
      return 1;
    }
    else {
      return -1;
    }
  }
  
  if (v1parts.length != v2parts.length) {
    return -1;
  }
  
  return 0;
}

export {
  formatCPFBr,
  formatCNPJBr,
  formatCarPlateBr,
  formatAccent,
  formatCURPMx,
  formatRUT,
  formatCURPCr,
  emitFormUpdate,
  getEnd,
  fireBase,
  getIosVerStr,
  isVerLessThan,
  openWebview,
  goThirdLink,
  getDomainSuffix,
  getLocation,
  computeJumpTime,
  computeStayTime,
  getCookie,
  compareVersions
}
